import { RenderElementProps } from 'slate-react';

export interface QuotePluginOptions {
  isReadOnly?: boolean;
}

export interface BaseQuotePluginProps extends RenderElementProps, QuotePluginOptions {}

export const K12_ELEMENT_QUOTE = 'k12-blog-blockquote';
